/**
 * Protocol version - must match between client and server
 */
export const PROTOCOL_VERSION = 1;
//# sourceMappingURL=version.js.map